module.exports = __webpack_public_path__ + "static/media/checkin.74063507.png";